export default __webpack_public_path__ + "static/050-a5e2f1579163db8f327c7f5dd52a45a7.jpg";